import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIModule } from './ui/ui.module';

import { WidgetModule } from './widget/widget.module';
import { SmartVolumetricAssistantComponent } from '../pages/catalogos/equipos/components/smart-volumetric-assistant.component/smart-volumetric-assistant.component';
import { NgbAccordionModule, NgbAlertModule, NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CatalogosRoutingModule } from '../pages/catalogos/catalogos-routing.module';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PipesModule } from '../core/pipes/pipes.module';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { LoadingComponent } from './ui/loading.component/loading.component';
import { TokenModalComponent } from './components/token-modal/token-modal.component';

@NgModule({
  declarations: [SmartVolumetricAssistantComponent,LoadingComponent, TokenModalComponent],
  imports: [
    CommonModule,
    UIModule,
    WidgetModule,

        NgbPaginationModule,
        NgbTypeaheadModule,
        NgbCollapseModule,
        NgbDropdownModule,
        FormsModule,
        Ng2SmartTableModule,
        Ng2SearchPipeModule,
        PipesModule,
        ReactiveFormsModule,
        DropzoneModule,
        NgbDatepickerModule,
        UiSwitchModule,
        NgSelectModule,
        NgxDropzoneModule,
        NgbNavModule,
        NgbAccordionModule,
        NgbAlertModule,
        DropzoneModule,
        NgxMaskModule.forRoot(),
        ToastrModule.forRoot({
          timeOut: 10000,
          positionClass: 'toast-top-right',
          preventDuplicates: true,
        }),
  ],
  exports:[SmartVolumetricAssistantComponent,LoadingComponent,TokenModalComponent]
})

export class SharedModule { }
